import {createReducer, on} from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";

import {
  addUser,
  addUserFailure,
  addUserSuccess, disableUser, disableUserFailure, disableUserSuccess,
  loadRoleDropDownData,
  loadRoleDropDownDataFailure,
  loadRoleDropDownDataSuccess,
  loadUsers,
  loadUsersFailure,
  loadUsersSuccess,
  modifyUser,
  modifyUserFailure,
  modifyUserSuccess,
  removeUser,
  removeUserFailure,
  removeUserSuccess,
  updateUsersRole, updateUsersRoleFailure,
  updateUsersRoleSuccess
} from "./user.action";
import {Role} from "../../../shared/models/role.model";
export interface UserState {
  users: any[];
  roleDropDownData: Role[];
  error: string | null;
  userStatus: StateStatus;
  roleDropDownStatus: StateStatus;
}

export const initialState: UserState = {
  users: [],
  roleDropDownData: [],
  error: null,
  userStatus: 'pending' as StateStatus,
  roleDropDownStatus: 'pending' as StateStatus,
};

export const userReducer = createReducer(
  initialState,
  on(loadUsers, (state) : UserState => ({ ...state, userStatus: 'loading' as StateStatus })),
  on(loadUsersSuccess, (state, { users }) : UserState => ({
    ...state,
    users: users,
    error: null,
    userStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadUsersFailure, (state, { error }) : UserState => ({
    ...state,
    error: error,
    userStatus: 'error' as StateStatus,
  })),
  on(addUser, (state, { user }) => ({
    ...state,
    userStatus: 'adding' as StateStatus,
  })),
  on(addUserSuccess, (state, { user }) : UserState => ({
    ...state,
    userStatus: 'addSuccess' as StateStatus,
    users: [
      user,
      ...state.users
    ],
  })),
  on(addUserFailure, (state, { error }) : UserState  => ({
    ...state,
    users: state.users,
    error: error,
    userStatus: 'error' as StateStatus,
  })),
  on(modifyUser, (state, { user }) : UserState  => ({
    ...state,
    userStatus: 'modifying' as StateStatus,
    users: state.users.map(originalUser => {
      return originalUser.id == user.id ? {
        ...originalUser,
        name: user.id,

      } : originalUser;
    }),
  })),
  on(modifyUserSuccess, (state, {user}) : UserState => ({
    ...state,
    error: null,
    userStatus: 'modifySuccess' as StateStatus,
  })),
  on(modifyUserFailure, (state, { error }) : UserState => ({
    ...state,
    users: state.users,
    error: error,
    userStatus: 'error' as StateStatus,
  })),

  on(disableUser, (state, { userId }) : UserState => ({
    ...state,
    userStatus: 'removing' as StateStatus
  })),
  on(disableUserSuccess, (state, { userId }) : UserState => ({
    ...state,
    users: state.users.filter((u) => u.id != userId),
    error: null,
    userStatus: 'removeSuccess' as StateStatus,
  })),
  on(disableUserFailure, (state, { error }) : UserState => ({
    ...state,
    error: error,
    userStatus: 'error' as StateStatus,
  })),

  on(loadRoleDropDownData, (state) : UserState => ({ ...state, roleDropDownStatus: 'loading' as StateStatus })),
  on(loadRoleDropDownDataSuccess, (state, { roles }) : UserState => ({
    ...state,
    roleDropDownData: roles,
    error: null,
    roleDropDownStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadRoleDropDownDataFailure, (state, { error }) : UserState => ({
    ...state,
    error: error,
    roleDropDownStatus: 'error' as StateStatus,
  })),

  on(updateUsersRole, (state) => ({
    ...state,
    userStatus: 'modifying' as StateStatus,
  })),
  on(updateUsersRoleSuccess, (state) => ({
    ...state,
    userStatus: 'modifySuccess' as StateStatus,
  })),
  on(updateUsersRoleFailure, (state) => ({
    ...state,
    userStatus: 'modifyError' as StateStatus,
  })),
);
